import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";

let API = {
  getPledges: ({ userID }) =>
    new FnrFetch3("/pledge/getUserPledges", { userID }),
  endPledge: ({ pledgeID }) =>
    new FnrFetch3("/pledge/endUserPledge", { pledgeID }),
};

export default API;
